import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";

export default function AdminWarehouseIssues() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/admin/warehouse-issues")
      .then(r => setRows(r.data))
      .catch(e => toast.error(formatApiError(e)))
      .finally(() => setLoading(false));
  }, []);
  return (
    <div data-testid="admin-wh-issues-page" className="space-y-5">
      <div>
        <div className="text-xs font-mono-tech uppercase tracking-[0.2em] text-cyan-400 mb-1">/ Warehouse</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Warehouse Issues</h1>
      </div>
      {loading ? <div className="py-14 text-center text-slate-500">Loading…</div> :
       rows.length === 0 ? (
        <div className="border border-dashed border-slate-200 dark:border-slate-800 rounded-lg py-14 text-center bg-slate-100/30 dark:bg-slate-900/30 text-slate-500">
          <AlertTriangle className="w-10 h-10 text-slate-700 mx-auto mb-3" /> No issues.
        </div>
       ) : (
        <div className="space-y-2">
          {rows.map(i => (
            <div key={i.id} className="border border-slate-200 dark:border-slate-800 rounded-lg p-4 bg-slate-100/40 dark:bg-slate-900/40">
              <div className="flex justify-between gap-2">
                <div>
                  <div className="font-display font-semibold text-amber-300">{i.issue_type}</div>
                  <div className="text-xs text-slate-600 dark:text-slate-400 font-mono-tech">{i.package_id || "—"} · {new Date(i.created_at).toLocaleString()}</div>
                </div>
                <span className="text-[10px] uppercase font-mono-tech tracking-wider px-2 py-0.5 rounded border bg-red-500/10 text-red-300 border-red-500/30">{i.status}</span>
              </div>
              {i.issue_notes && <div className="text-sm text-slate-700 dark:text-slate-300 mt-2">{i.issue_notes}</div>}
              <div className="text-[11px] text-slate-500 mt-2">by {i.reported_by_name} · {i.warehouse_name}</div>
            </div>
          ))}
        </div>
       )}
    </div>
  );
}
